<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ appointmentNumber ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.SaveAsDraft)">
        <dx-button text="Save As Draft" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.SaveAsDraft)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.Submit)">
        <dx-button text="Submit" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.Submit)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.Approve)">
        <dx-button text="Approve" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.Approve)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.CheckedIn)">
        <dx-button text="Check In" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.CheckedIn)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.InvestigationCompleted)">
        <dx-button text="Investigation Completed" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.InvestigationCompleted)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.Complete)">
        <dx-button text="Complete" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onCompleteClick()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.AcceptLoad)">
        <dx-button text="Accept Load" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.AcceptLoad)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.TagsAsnPgiConfirmed)">
        <dx-button text="Tags/ASN/PGI Confirmed" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.TagsAsnPgiConfirmed)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(AppointmentAction.CompleteMove)">
        <dx-button text="Complete Move" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(AppointmentAction.CompleteMove)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="showMoreMenu">
        <dx-drop-down-button text="More" icon="overflow" [dropDownOptions]="{ width: 210 }" [items]="moreMenuActions"
            [splitButton]="false" stylingMode="outlined" type="default" displayExpr="text" keyExpr="id"
            [disabled]="isSubmitting" (onItemClick)="onMenuActionClick($event)" class="ms-2">
        </dx-drop-down-button>
    </dxi-item>
</dx-toolbar>